import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import type { UpsellSeenKind } from 'fym-shared/src/music24/watermarkUpsell';
import { useTRPCAPI, useTRPCMutation } from '../../../trpc/trpc';

/**
 * `onboarding.markUpsellSeen`: an automatic modal opened, so it must not open again for this user
 * on any client. The server sets the date only when it is null. Then `onboarding.state` is read
 * again. A failure only logs: the modal is open already.
 */
export function useMarkUpsellSeen(): (kind: UpsellSeenKind) => void {
  const trpcAPI = useTRPCAPI();
  const queryClient = useQueryClient();
  const { mutateAsync } = useTRPCMutation(trpcAPI.onboarding.markUpsellSeen.mutationOptions());
  return useCallback(
    (kind: UpsellSeenKind) => {
      mutateAsync({ kind })
        .then(() => queryClient.invalidateQueries({ queryKey: trpcAPI.onboarding.state.queryKey() }))
        .catch(console.error);
    },
    [mutateAsync, queryClient, trpcAPI]
  );
}
